module.exports = __webpack_public_path__ + "static/media/LegoCaveSpiderQueenThroneLairA0002_design_clean_v001.d09db90d.png";